import { useInfiniteQuery } from '@tanstack/react-query';
import { InView, When } from '@teamsparta/react';

import type {
  CommunityPostCommentSortBy,
  GetCommunityPostCommentsResponseDto,
} from '@/api/community/comment/comment.dto';
import { communityPostCommentsInfiniteQuery } from '@/hooks/react-query/community/comment';

import { Comment } from '../Comment';

interface Props {
  postId: string;
  comments: GetCommunityPostCommentsResponseDto | null;
  sortBy: CommunityPostCommentSortBy;
}

export function Comments({
  postId,
  comments: commentsFromServer,
  sortBy,
}: Props) {
  const { data, fetchNextPage, isFetchingNextPage, hasNextPage } =
    useInfiniteQuery(communityPostCommentsInfiniteQuery({ postId, sortBy }));
  const comments =
    data?.pages.flatMap((page) => page.comments) ??
    commentsFromServer?.comments ??
    [];

  function handleEnter() {
    if (hasNextPage && !isFetchingNextPage) {
      fetchNextPage();
    }
  }

  return (
    <>
      {comments?.map((comment) => (
        <Comment key={comment._id} {...comment} postId={postId} />
      ))}
      <When condition={!isFetchingNextPage}>
        <InView onEnter={handleEnter}>
          <div style={{ height: 1 }} />
        </InView>
      </When>
    </>
  );
}
